import { Feature, Role } from '@/enum/global.enum'
import {
  Activity,
  AlertTriangle,
  AlignVerticalJustifyEnd,
  Archive,
  BarChart3,
  Bell,
  Blocks,
  BookOpen,
  Bot,
  BrainCircuit,
  Bug,
  CalendarCheck,
  CalendarRange,
  ChartBar,
  ChartLine,
  ClipboardCheck,
  ClipboardList,
  Coins,
  CreditCard,
  Database,
  DatabaseZap,
  Earth,
  FileBox,
  FileCode2,
  FileSpreadsheet,
  FileText,
  FolderArchive,
  FolderCog,
  GitGraph,
  Globe,
  GraduationCap,
  HeartPulse,
  Key,
  KeyRound,
  Landmark,
  Layers,
  LayoutDashboard,
  LayoutList,
  LayoutPanelTop,
  Link,
  Lock,
  Logs,
  Mail,
  MailSearch,
  Map,
  MessageCircleQuestionMark,
  MessageSquareCode,
  MessagesSquare,
  Network,
  Package,
  Radar,
  Receipt,
  RefreshCcw,
  ScrollText,
  Server,
  Settings,
  Settings2,
  ShieldAlert,
  ShieldAlertIcon,
  ShieldCheck,
  Sparkles,
  Tag,
  Target,
  UserCog,
  UserCog2,
  UserPlus,
  UserPlus2,
  UserSquare2,
  UserCheck,
} from 'lucide-react'

export const orgMenu = {
  navMain: [
    {
      title: 'Dashboard',
      url: '/',
      icon: LayoutDashboard,
      role: [Role.ORG_ADMIN, Role.ORG_MANAGER, Role.ORG_CONSULTANT, Role.ORG_VIEWER, Role.ORG_LEAD_QSA],
    },
    {
      title: 'Organisational Context',
      url: '/organisational-context',
      icon: Earth,
      feature: Feature.ORGANISATIONAL_CONTEXT,
    },
    {
      title: 'Governance',
      url: '#',
      icon: Landmark,
      items: [
        {
          title: 'Policies & Procedures ',
          url: '#',
          icon: FileText,
          feature: Feature.POLICY,
          items: [
            {
              title: 'Dashboard',
              url: '/policy-dashboard',
              icon: LayoutPanelTop,
              feature: Feature.POLICY,
            },
            {
              title: 'Policy Register',
              url: '/policy',
              icon: FileText,
              feature: Feature.POLICY,
            },
            {
              title: 'Exemptions Register',
              url: '/exemptions-register',
              icon: Lock,
              feature: Feature.EXEMPTIONS_REGISTER,
            },
          ],
        },
        {
          title: 'Project Management',
          url: '#',
          icon: ClipboardList,
          feature: Feature.PROJECT,
          items: [
            {
              title: 'Dashboard',
              url: '/tasks-dashboard',
              icon: LayoutList,
              feature: Feature.PROJECT,
            },
            {
              title: 'Manage Projects',
              url: '/manage-projects',
              icon: ClipboardList,
              feature: Feature.PROJECT,
              activeUrls: ['/manage-projects/tasks'],
            },
          ],
        },
        {
          title: 'Meeting Minutes',
          url: '/meeting-minutes',
          icon: CalendarRange,
          feature: Feature.MEETING_MINUTES,
        },
        {
          title: 'Supply Chain Management',
          url: '#',
          icon: Landmark,
          feature: Feature.SERVICE_PROVIDER,
          items: [
            {
              title: 'Dashboard',
              url: '/service-provider-dashboard',
              icon: LayoutDashboard,
              feature: Feature.SERVICE_PROVIDER,
            },
            {
              title: 'Register',
              url: '/service-provider-list',
              icon: Landmark,
              feature: Feature.SERVICE_PROVIDER,
              activeUrls: ['/add-service-provider', '/service-provider', 'settings/service-provider/risk-tier-matrix'],
            },
            {
              title: 'Questionnaire Library',
              url: '/assessment-library',
              icon: FileSpreadsheet,
              feature: Feature.SERVICE_PROVIDER,
              activeUrls: ['/add-assessment-library'],
            },
            {
              title: 'Assessment',
              url: '/service-provider-assessment',
              icon: ClipboardCheck,
              feature: Feature.SERVICE_PROVIDER,
              activeUrls: [
                '/add-service-provider-assessment',
                '/service-provider-assessment',
                '/service-provider-ai-risk',
              ],
            },
            {
              title: 'Incoming Questionnaire',
              url: '/service-provider-incoming-questionnaire',
              activeUrls: ['/service-provider-incoming-questionnaire'],
              icon: ClipboardList,
              feature: Feature.SERVICE_PROVIDER,
            },
            {
              title: 'Report Library',
              url: '/service-provider-report-library',
              icon: FileText,
              feature: Feature.SERVICE_PROVIDER,
            },
          ],
        },
        {
          title: 'Staff Register',
          url: '/manage-staff',
          icon: UserPlus,
          feature: Feature.STAFF,
        },
        {
          title: 'Document Repository',
          url: '/document-repo',
          icon: FolderArchive,
          feature: Feature.DOCUMENT_REPOSITORY,
          activeUrls: ['/document-repo'],
        },
        {
          title: 'Regulatory Register',
          url: '/country-regulatory-register-oos',
          icon: Globe,
          feature: Feature.COUNTRY_REGULATORY_REGISTER,
        },
        {
          title: 'Change Management Process',
          url: '/change-management-process',
          icon: RefreshCcw,
          feature: Feature.CHANGE_MANAGEMENT_PROCESS,
        },
        {
          title: 'Information Security Objectives',
          url: '/information-security-objectives',
          icon: Target,
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
          activeUrls: ['/information-security-objectives', '/add-information-security-objective'],
        },
        {
          title: 'ISMS Assurance Calendar',
          url: '/isms-assurance-calendar',
          icon: CalendarCheck,
          feature: Feature.ISMS_ASSURANCE_CALENDAR,
        },
        {
          title: 'Security Awareness',
          icon: GraduationCap,
          url: '#',
          items: [
            {
              title: 'Phished',
              url: '/security-awareness/phished',
              icon: ShieldAlert,
              feature: Feature.PHISHED,
            },
            {
              title: 'Mimecast',
              url: '/security-awareness/mimecast',
              icon: ShieldCheck,
              feature: Feature.MIMECAST,
            },
          ],
        },
        {
          title: 'Manage AI Register',
          url: '#',
          icon: Sparkles,
          feature: Feature.AI_REGISTER,
          items: [
            {
              title: 'Dashboard',
              url: '/ai-register/dashboard',
              icon: LayoutDashboard,
              feature: Feature.AI_REGISTER,
            },
            {
              title: 'AI Register',
              url: '/ai-register',
              icon: Sparkles,
              feature: Feature.AI_REGISTER,
            },
          ],
        },
      ],
    },
    {
      title: 'Risk',
      url: '#',
      icon: ShieldAlert,
      feature: Feature.RISK,
      items: [
        {
          title: 'Manage Risk',
          url: '#',
          icon: ClipboardList,
          feature: Feature.RISK,
          items: [
            {
              title: 'Dashboard',
              url: '/risk-dashboard',
              icon: LayoutPanelTop,
              feature: Feature.RISK,
            },
            {
              title: 'Risk Register',
              url: '/risk-list',
              icon: ClipboardList,
              feature: Feature.RISK,
              activeUrls: ['/risk-list', '/add-risk'],
            },
            {
              title: 'Plan Of Action',
              url: '/plan-of-action',
              icon: LayoutList,
              feature: Feature.RISK,
            },
            {
              title: 'Risk Assessment',
              icon: ClipboardCheck,
              url: '#',
              items: [
                {
                  title: 'System Risk Assessment',
                  url: '/risk-assessment',
                  icon: ShieldCheck,
                  feature: Feature.RISK_ASSESSMENT,
                },
                {
                  title: 'People Risk Assessment',
                  url: '/people-risk-assessment',
                  icon: UserCheck,
                  feature: Feature.PEOPLE_RISK_ASSESSMENT,
                },
              ],
            },
          ],
        },
        {
          title: 'Manage Assets',
          icon: Layers,
          url: '#',
          feature: Feature.INFORMATION_ASSET,
          items: [
            {
              title: 'Dashboard',
              icon: ChartBar,
              url: '/information-asset-report',
              feature: Feature.INFORMATION_ASSET,
            },
            {
              title: 'Assets Register',
              icon: Layers,
              url: '/information-asset',
              feature: Feature.INFORMATION_ASSET,
            },
          ],
        },
        {
          title: 'Incident',
          url: '#',
          icon: Radar,
          feature: Feature.INCIDENT_REGISTER,
          items: [
            {
              title: 'Dashboard',
              url: '/incident-dashboard',
              icon: Radar,
              feature: Feature.INCIDENT_REGISTER,
            },
            {
              title: 'Incident Register',
              url: '/incident',
              icon: ClipboardList,
              feature: Feature.INCIDENT_REGISTER,
              activeUrls: ['/add-incident'],
            },
          ],
        },
        {
          title: 'Vulnerability',
          url: '#',
          icon: Bug,
          feature: Feature.RISK,
          items: [
            {
              title: 'Dashboard',
              url: '/risk/vulnerability/dashboard',
              icon: LayoutDashboard,
              feature: Feature.RUN_ZERO_ASSET,
            },
            {
              title: 'Vulnerability Register',
              url: '/risk/vulnerability',
              icon: Bug,
              feature: Feature.RISK,
            },
          ],
        },
        {
          title: 'Cyber Threat Risk Assessment',
          url: '#',
          icon: ShieldAlertIcon,
          feature: Feature.CTRA,
          items: [
            {
              title: 'Manage Programs',
              url: '/ctra/programs',
              icon: FolderCog,
              feature: Feature.CTRA,
            },
            {
              title: 'Manage Asset Zones',
              url: '/ctra/zones',
              icon: Network,
              feature: Feature.CTRA,
            },
            {
              title: 'Manage Engagements',
              url: '/ctra/engagements',
              activeUrls: ['ctra/engagements', '/ctra/engagements/add'],
              icon: ClipboardList,
              feature: Feature.CTRA,
            },
            {
              title: 'Manage SOA',
              url: '/ctra/manage-soa',
              icon: FileSpreadsheet,
              feature: Feature.CTRA,
            },
            {
              title: 'Threat Scenario',
              url: '/ctra/threat-scenario',
              icon: ShieldAlert,
              feature: Feature.CTRA,
            },
          ],
        },
      ],
    },
    {
      title: 'Compliance',
      url: '#',
      icon: FolderCog,
      feature: Feature.ASSESSMENTS,
      items: [
        {
          title: 'Dashboard',
          url: '/compliance-report',
          icon: LayoutPanelTop,
          feature: Feature.ASSESSMENTS,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Standards & Assessments',
          url: '/assessments',
          icon: ClipboardList,
          feature: Feature.ASSESSMENTS,
          activeUrls: ['/assessments'],
        },
        {
          title: 'Archive Assessment',
          url: '/archive-assessment',
          icon: Archive,
          feature: Feature.ASSESSMENTS,
          activeUrls: ['/archive-assessment'],
          role: [Role.ORG_ADMIN],
        },
        {
          title: 'Report Library',
          url: '/report-library',
          icon: FileBox,
          feature: Feature.REPORT_LIBRARY,
        },
        {
          title: 'Issues',
          url: '/issues/non-conformities',
          icon: AlertTriangle,
          feature: Feature.ASSESSMENTS,
          activeUrls: ['/issues'],
        },
        {
          title: 'Statement Of Applicability',
          url: '/statement-of-applicability',
          icon: ClipboardCheck,
          feature: Feature.ASSESSMENTS,
        },
        // Hidden: Quarantine Management
        // {
        //   title: 'Quarantine Management ',
        //   url: '/quarantine-management',
        //   icon: ShieldAlert,
        //   role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        //   feature: Feature.ASSESSMENTS,
        // },
      ],
    },
    {
      title: 'Settings',
      url: '/settings',
      icon: Settings2,
      role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
      hidden: true,
      items: [
        // Policy Settings
        {
          title: 'Policy Categories',
          url: '/settings/policy/policy-category',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.POLICY,
        },
        {
          title: 'Policy Update Frequencies',
          url: '/settings/policy/policy-frequencies',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.POLICY,
        },
        {
          title: 'Policy Dashboard Benchmarks',
          url: '/settings/policy/dashboard-benchmarks',
          role: [Role.ORG_ADMIN],
          feature: Feature.POLICY,
        },
        {
          title: 'Default Policy Reviewer',
          url: '/settings/policy/default-policy-reviewer',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.POLICY,
        },
        {
          title: 'Change Management Process Category',
          url: '/settings/change-management-process-category',
          icon: FileSpreadsheet,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.CHANGE_MANAGEMENT_PROCESS,
        },
        {
          title: 'Meeting Minutes Type',
          url: '/meeting-minutes-type',
          icon: ClipboardList,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.MEETING_MINUTES,
        },

        // Task Settings
        {
          title: 'Task Status',
          url: '/settings/task/task-status',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.PROJECT,
        },
        {
          title: 'Task Severity',
          url: '/settings/task/task-severity',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.PROJECT,
        },
        // Supply Chain Management Settings
        {
          title: 'Supply Chain Contract Status',
          url: '/settings/service-provider/service-provider-contract-status',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        {
          title: 'Service Type',
          url: '/settings/service-provider/service-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        {
          title: 'Assessment Tier',
          url: '/settings/service-provider/assessment-tier',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        {
          title: 'Supply Chain Criticality',
          url: '/settings/service-provider/assessment-tier-criticality',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        {
          title: 'Supply Chain Sensitivity',
          url: '/settings/service-provider/assessment-tier-sensitivity',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        // Risk matrix
        {
          title: 'Supply Chain Risk Matrix',
          url: '/settings/service-provider/risk-tier-matrix',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        // Evaluation engine settings
        {
          title: 'Control Mapping',
          url: '/settings/service-provider/control-mapping',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        {
          title: 'Scoring Rubric',
          url: '/settings/service-provider/scoring-rubric',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        // Risk review intervals
        {
          title: 'Risk Review Intervals',
          url: '/settings/service-provider/risk-review-intervals',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.SERVICE_PROVIDER,
        },
        // Risk
        {
          title: 'Risk Likelihood',
          url: '/settings/risk/risk-likelihood',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Risk Impact',
          url: '/settings/risk/risk-impact',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Risk Rating',
          url: '/settings/risk/risk-rating',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Risk Matrix',
          url: '/settings/risk/risk-matrix',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Risk Categories',
          url: '/settings/risk/risk-categories',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Risk Treatment',
          url: '/settings/risk/treatment',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Risk Identification Source',
          url: '/settings/risk/risk-identification-source',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Incident Type',
          url: '/settings/risk/incident-types',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Vulnerability',
          url: '/settings/risk/vulnerability',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Threat Category',
          url: '/settings/risk/threat-category',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Threat Source',
          url: '/settings/risk/threat-source',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Threat Actor',
          url: '/settings/risk/threat-actor',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        {
          title: 'Manage Threat',
          url: '/settings/risk/threat',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.RISK,
        },
        // Non-Conformity Settings
        {
          title: 'Root Identification',
          url: '/settings/non-conformity/root-identification',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Affected Area',
          url: '/settings/non-conformity/affected-area',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Importance',
          url: '/settings/non-conformity/importance',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Action Status',
          url: '/settings/non-conformity/action-status',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Asset Type',
          url: '/settings/information-asset/asset-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_ASSET,
        },
        {
          title: 'Jurisdiction',
          url: '/country-regulatory-register-oos/jurisdiction',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.COUNTRY_REGULATORY_REGISTER,
        },
        {
          title: 'Operation Type',
          url: '/country-regulatory-register-oos/operation-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.COUNTRY_REGULATORY_REGISTER,
        },
        {
          title: 'Regulatory Category',
          url: '/country-regulatory-register-oos/regulatory-category',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.COUNTRY_REGULATORY_REGISTER,
        },
        {
          title: 'Region',
          url: '/country-regulatory-register-oos/region',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.COUNTRY_REGULATORY_REGISTER,
        },
        {
          title: 'Risk Type',
          url: '/country-regulatory-register-oos/risk-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.COUNTRY_REGULATORY_REGISTER,
        },

        // others
        {
          title: 'Utility Settings',
          url: '/settings/utility',
        },
        {
          title: 'Required Fields',
          url: '/settings/field-requirements',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },

        {
          title: 'Manage Department',
          url: '/manage-department',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.STAFF,
        },
        {
          title: 'API Integrations',
          url: '/settings/external-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Vanta Integration',
          url: '/settings/vanta-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.VANTA,
        },
        {
          title: 'Drata Integration',
          url: '/settings/drata-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.DRATA,
        },
        {
          title: 'Jira Integration',
          url: '/settings/jira-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Azure Integration',
          url: '/settings/azure-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.AZURE,
        },
        {
          title: 'Confluence Integration',
          url: '/settings/confluence-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.CONFLUENCE,
        },
        {
          title: 'Palo Alto Networks Integration',
          url: '/settings/palo-alto-networks-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.PALO_ALTO,
        },
        {
          title: 'MS Defender Integration',
          url: '/settings/ms-defender-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.MS_DEFENDER,
        },

        {
          title: 'Mimecast Integration',
          url: '/settings/mimecast-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.MIMECAST,
        },
        {
          title: 'SharePoint Configuration',
          url: '/organisation/sharepoint-config',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Google Drive Integration',
          url: '/settings/google-drive-integration',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.GOOGLE_DRIVE,
        },
        {
          title: 'Email Configuration',
          url: '/settings/email-configuration',
          role: [Role.ORG_ADMIN],
        },
        {
          title: 'n8n Integration',
          url: '/settings/n8n-webhook',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.N8N,
        },
        {
          title: 'Zapier Integration',
          url: '/settings/zapier-webhook',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ZAPIER,
        },
        {
          title: 'Password Policy',
          url: '/settings/security/password-policy',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.USERS,
        },
        {
          title: 'Signature Settings',
          url: '/settings/security/signature-settings',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Single Sign-On',
          url: '/settings/security/sso',
          role: [Role.ORG_ADMIN],
        },
        {
          title: 'QSA/ISA Credential Registry',
          url: '/settings/credential-registry',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Organisation Preference',
          url: '/settings/organisation-preference',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Roles & Permissions',
          url: '/settings/roles-and-permissions',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.USERS,
        },
        {
          title: 'Access Type',
          url: '/settings/pci-scope/people/access-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Training Type',
          url: '/settings/pci-scope/people/training-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Data Handling Type',
          url: '/settings/pci-scope/process/data-handling-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'Frequency Type',
          url: '/settings/pci-scope/process/frequency-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.ASSESSMENTS,
        },
        {
          title: 'AI Register Type',
          url: '/settings/ai-register/type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.AI_REGISTER,
        },
        {
          title: 'Permitted Data',
          url: '/settings/ai-register/permitted-data',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.AI_REGISTER,
        },
        {
          title: 'AI Screening Questionnaire',
          url: '/settings/ai-register/screening-questionnaire',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.AI_REGISTER,
        },
        // Information Security Objectives Settings
        {
          title: 'Objective Status',
          url: '/settings/information-security-objectives/status',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
        },
        {
          title: 'Objective Priority',
          url: '/settings/information-security-objectives/priority',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
        },
        {
          title: 'Objective Reporting Format',
          url: '/settings/information-security-objectives/reporting-format',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
        },
        {
          title: 'Objective Analysis & Evaluation Frequency',
          url: '/settings/information-security-objectives/analysis-evaluation-frequency',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
        },
        {
          title: 'Objective Monitoring Frequency',
          url: '/settings/information-security-objectives/monitoring-frequency',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
        },
        {
          title: 'Objective Measure Type',
          url: '/settings/information-security-objectives/measure-type',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
        },
        {
          title: 'Objective Area',
          url: '/settings/information-security-objectives/area',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.INFORMATION_SECURITY_OBJECTIVE,
        },
        {
          title: 'Classification Label',
          url: '/settings/classification-label',
        },
        {
          title: 'PDF Templates',
          url: '/settings/pdf-template',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Profile',
          url: '/settings/profile',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'MFA Setup',
          url: '/settings/mfa',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Toaster Settings',
          url: '/settings/utility/toaster',
          role: [Role.ORG_ADMIN],
        },
      ],
    },

    {
      title: 'Settings',
      url: '/settings',
      role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
      icon: Settings2,
      hideCommandMenu: true,
      activeUrls: ['/settings'],
    },
  ],
  others: [
    {
      title: 'Manage Organisation',
      url: '/manage-organisation',
      icon: Landmark,
      role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
      feature: Feature.SUB_ORGANISATION,
    },
    {
      title: 'Manage CISO Adapt Users',
      url: '/manage-users',
      icon: UserCog,
      role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
      feature: Feature.USERS,
    },
    {
      title: 'AI',
      url: '#',
      icon: Sparkles,
      items: [
        {
          title: 'AI Models (API)',
          url: '/organisation/ai-model',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.AI_MODEL,
          icon: Sparkles,
        },
        {
          title: 'AI Token Usages',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          url: '/organisation/ai-token-usage',
          icon: Activity,
        },
        {
          title: 'AI Changes',
          url: '/organisation/ai-changes',
          feature: Feature.POLICY,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          icon: ClipboardCheck,
        },
      ],
    },
    {
      title: 'API',
      url: '#',
      icon: Key,
      items: [
        {
          title: 'API Integrations',
          url: '/settings/external-integration',
          icon: Key,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          activeUrls: [
            '/organisation/sharepoint-config',
            '/settings/vanta-integration',
            '/settings/drata-integration',
            '/settings/palo-alto-networks-integration',
            '/settings/jira-integration',
            '/settings/zapier-webhook',
            '/settings/n8n-webhook',
            '/settings/google-drive-integration',
            '/settings/email-configuration',
            '/settings/azure-integration',
            '/settings/confluence-integration',
            '/settings/mimecast-integration',
            '/settings/ms-defender-integration',
          ],
        },
        {
          title: 'API Tokens',
          url: '/settings/api-tokens',
          icon: KeyRound,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
      ],
    },
    {
      title: 'Logging and monitoring',
      url: '#',
      icon: Logs,
      items: [
        {
          title: 'Email Logs',
          url: '/email-logs',
          icon: MailSearch,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'Users Activity Logs',
          url: '/activity-logs/all-users',
          icon: Activity,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.USERS,
        },
        {
          title: 'Activity Analytics',
          url: '/activity-analytics',
          icon: ChartLine,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          feature: Feature.USERS,
        },
        {
          title: 'Login Logs',
          url: '/login-logs',
          icon: Logs,
        },
      ],
    },
    {
      title: 'Resources',
      url: '#',
      icon: BookOpen,
      items: [
        {
          title: 'FAQ',
          url: '/organisation/resource',
          icon: MessageCircleQuestionMark,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
        {
          title: 'User Manual',
          url: '/user-manual',
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
          icon: BookOpen,
        },
        // {
        //   title: 'Release Notes',
        //   url: '/release-notes',
        //   role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        //   icon: GitGraph,
        // },
        {
          title: 'Bug Report/Feature Request',
          url: '/bug-report',
          icon: Bug,
          role: [Role.ORG_ADMIN, Role.ORG_MANAGER],
        },
      ],
    },
  ],
}

export const vendorMenu = {
  navMain: [
    {
      title: 'Dashboard',
      url: '/',
      icon: LayoutDashboard,
      role: [Role.VENDOR, Role.VENDOR_COLLABORATOR],
    },
    {
      title: 'Assessment Lists',
      url: '/vendor/assessments',
      icon: ClipboardCheck,
      role: [Role.VENDOR, Role.VENDOR_COLLABORATOR],
    },
  ],
}

export const adminMenu = {
  navMain: [
    {
      title: 'Admin Dashboard',
      url: '/',
      icon: LayoutDashboard,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
    },
    {
      title: 'Manage ',
      url: '#',
      icon: Settings,
      isActive: true,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      items: [
        {
          title: 'Standards',
          url: '#',
          icon: LayoutPanelTop,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_STANDARDS,
          items: [
            {
              title: 'Standards',
              url: '/admin/standards',
              icon: LayoutPanelTop,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_STANDARDS,
            },
            {
              title: 'Standard Levels',
              url: '/admin/standard-levels',
              icon: AlignVerticalJustifyEnd,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_STANDARDS,
            },
            {
              title: 'SAQ Types',
              url: '/admin/saq-types',
              icon: FileSpreadsheet,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_STANDARDS,
            },
            {
              title: 'Fiscal Years',
              url: '/admin/fiscal-years',
              icon: CalendarRange,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_STANDARDS,
            },
            {
              title: 'Module Settings',
              url: '/admin/module',
              icon: LayoutList,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_STANDARDS,
            },
            {
              title: 'Manage PCI (Evidence Pack) Tasks',
              url: '/admin/pci-dss-evidence-pack-task',
              icon: FileSpreadsheet,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_STANDARDS,
            },
          ],
        },
        {
          title: 'Controls',
          url: '#',
          icon: ShieldAlert,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_CONTROLS,
          items: [
            {
              title: 'Control Groups',
              url: '/admin/control-groups',
              icon: Layers,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_CONTROLS,
            },
            {
              title: 'Controls',
              url: '/admin/controls',
              icon: ShieldAlert,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_CONTROLS,
            },
            {
              title: 'Control Mapping',
              url: '/admin/control-mapping',
              icon: Link,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_CONTROLS,
            },
            {
              title: 'Control Questionnaires',
              url: '/admin/control-questionnaires',
              icon: MessageCircleQuestionMark,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_CONTROLS,
            },
            {
              title: 'Vendor Evaluation Baseline',
              url: '/admin/vendor-baseline',
              icon: ClipboardCheck,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_CONTROLS,
            },
          ],
        },
        {
          title: 'Maturity',
          url: '#',
          icon: BarChart3,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_MATURITY_MODELS,
          items: [
            {
              title: 'Maturity Models',
              url: '/admin/maturity-models',
              icon: LayoutList,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_MATURITY_MODELS,
            },
            {
              title: 'Maturity Levels',
              url: '/admin/maturity-levels',
              icon: BarChart3,
              role: [Role.SUPER_ADMIN, Role.ADMIN],
              feature: Feature.ADMIN_MATURITY_MODELS,
            },
          ],
        },
      ],
    },
    {
      title: 'AI RAG',
      url: '#',
      icon: BrainCircuit,
      role: [Role.SUPER_ADMIN],
      items: [
        {
          title: 'Agents',
          url: '/admin/ai-rag/agents',
          icon: Bot,
        },
        {
          title: 'Policy Templates',
          url: '/admin/ai-rag/policy-templates',
          icon: FileCode2,
        },
        {
          title: 'Policy Packs',
          url: '/admin/ai-rag/policy-packs',
          icon: Package,
        },
        {
          title: 'Control Embeddings',
          url: '/admin/ai-rag/control-embeddings',
          icon: Layers,
        },
        {
          title: 'Evidence Index',
          url: '/admin/ai-rag/evidence-index',
          icon: FileBox,
        },
        {
          title: 'AI Activity Log',
          url: '/admin/ai-rag/activity-log',
          icon: ScrollText,
        },
        {
          title: 'AI Service Token Usage',
          url: '/admin/ai-rag/token-usage',
          icon: Coins,
        },
        {
          title: 'AI Service Status',
          url: '/admin/ai-rag/service-status',
          icon: HeartPulse,
        },
      ],
    },
    {
      title: 'Manage AI',
      url: '#',
      icon: Sparkles,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      items: [
        {
          title: 'Manage AI Models',
          url: '/admin/ai-models',
          icon: Radar,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_AI_MODEL,
        },
        {
          title: 'AI Token Usages',
          url: '/admin/ai-token-usage',
          icon: Activity,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_AI_MODEL,
        },
        {
          title: 'AI Prompt Catalog',
          url: '/admin/ai-prompt-catalog',
          icon: MessageSquareCode,
          role: [Role.SUPER_ADMIN],
        },
        {
          title: 'AI Assistant Chat History',
          url: '/admin/assistant-chat-history',
          icon: MessagesSquare,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_ORGANISATION,
        },
      ],
    },
    {
      title: 'System Risk Assessment Setup',
      url: '#',
      icon: ShieldAlert,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      feature: Feature.ADMIN_RISK_ASSESSMENT,
      items: [
        {
          title: 'System Exposure',
          url: '/admin/risk-assessment/system-exposure',
          icon: Radar,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'Hosting Model',
          url: '/admin/risk-assessment/hosting-model',
          icon: Server,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'Data Classification',
          url: '/admin/risk-assessment/data-classification',
          icon: Layers,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'User Base',
          url: '/admin/risk-assessment/user-base',
          icon: UserSquare2,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RISK_ASSESSMENT,
        },
        {
          title: 'Assessment Type',
          url: '/admin/risk-assessment/assessment-type',
          icon: Layers,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RISK_ASSESSMENT,
        },
        {
          title: 'Questionnaire Library',
          url: '/admin/risk-assessment/questionnaire-library',
          icon: FileSpreadsheet,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RISK_ASSESSMENT,
        },
      ],
    },
    {
      title: 'People Risk Assessment Setup',
      url: '#',
      icon: UserCheck,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      feature: Feature.ADMIN_PEOPLE_RISK_ASSESSMENT,
      items: [
        {
          title: 'Assessment Type',
          url: '/admin/people-risk-assessment/assessment-type',
          icon: Layers,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_PEOPLE_RISK_ASSESSMENT,
        },
        {
          title: 'Questionnaire Library',
          url: '/admin/people-risk-assessment/questionnaire-library',
          icon: FileSpreadsheet,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_PEOPLE_RISK_ASSESSMENT,
        },
      ],
    },
    {
      title: 'Manage Organisations',
      url: '#',
      icon: LayoutPanelTop,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      feature: Feature.ADMIN_ORGANISATION,
      items: [
        {
          title: 'Organisations List',
          url: '/admin/organisations',
          icon: Landmark,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'Organisation Users',
          url: '/admin/organisation-users',
          icon: UserPlus,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'Clerk Users',
          url: '/admin/clerk-users',
          icon: UserCog2,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'Manage Assessment',
          url: '/admin/assessment',
          icon: ClipboardCheck,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'Dashboard Chart Types',
          url: '/admin/dashboard-defaults',
          icon: LayoutDashboard,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
      ],
    },
    {
      title: 'Manage Subscription',
      url: '#',
      icon: CreditCard,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      feature: Feature.ADMIN_ORGANISATION,
      items: [
        {
          icon: Receipt,
          title: 'Organisation Subscription',
          url: '/admin/subscriptions',
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          icon: Package,
          title: 'Manage Subscription Type',
          url: '/admin/subscription-type',
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
      ],
    },
    {
      title: 'Manage Admin',
      url: '#',
      icon: Settings2,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      feature: Feature.ADMIN_ADMIN_MANAGE,
      items: [
        {
          icon: UserPlus,
          title: 'Admins List',
          url: '/admin/admins',
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
      ],
    },
    {
      title: 'Signup Requests',
      url: '/admin/signup-request',
      icon: UserPlus2,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      feature: Feature.ADMIN_ORGANISATION,
    },
    {
      title: 'Resources',
      url: '#',
      icon: BookOpen,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      items: [
        {
          title: 'Manage FAQ',
          url: '/admin/resources',
          icon: FileSpreadsheet,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage User Manual',
          url: '/admin/user-manual',
          icon: BookOpen,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage Helpful Tips',
          url: '/admin/helpful-tips',
          icon: MessageCircleQuestionMark,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage User Guides',
          url: '/admin/user-guides',
          icon: Map,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage Release Notes',
          url: '/admin/release-notes',
          icon: GitGraph,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage Email Templates',
          url: '/admin/email-template',
          icon: Mail,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_EMAIL_CUSTOMIZATION,
        },
        {
          title: 'Manage PDF Templates',
          url: '/admin/common-pdf-template',
          icon: FileText,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage Bug/Feature Request',
          url: '/admin/bug-report',
          icon: Bug,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Phished Recipient Tag Color',
          url: '/admin/phished-recipient-tag-color',
          icon: Tag,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
      ],
    },
    {
      title: 'System',
      url: '#',
      icon: Server,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      items: [
        {
          title: 'Manage MCP Server Extension',
          url: '/admin/mcp-server-extension',
          icon: Blocks,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage IT Privileged Operations',
          url: '/admin/it-privileged-operations',
          icon: ShieldAlert,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_IT_PRIVILEGED_OPERATIONS,
        },
        {
          title: 'Scheduler Config',
          url: '/admin/scheduler-config',
          icon: Activity,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'AI Database',
          url: '/admin/ai-database',
          icon: Database,
          role: [Role.SUPER_ADMIN],
          feature: Feature.ADMIN_IT_PRIVILEGED_OPERATIONS,
        },
        {
          title: 'Database',
          url: '/admin/database',
          icon: DatabaseZap,
          role: [Role.SUPER_ADMIN],
          feature: Feature.ADMIN_IT_PRIVILEGED_OPERATIONS,
        },
      ],
    },
    {
      title: 'Logs',
      url: '#',
      icon: Logs,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      items: [
        {
          title: 'Email Logs',
          url: '/admin/email-logs',
          icon: MailSearch,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage Activity Logs',
          url: '/admin/activity-logs',
          icon: Activity,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Activity Analytics',
          url: '/admin/activity-analytics',
          icon: ChartLine,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
      ],
    },
    {
      title: 'Tokens',
      url: '#',
      icon: KeyRound,
      role: [Role.SUPER_ADMIN, Role.ADMIN],
      items: [
        {
          title: 'Manage API Tokens',
          url: '/admin/api-docs-tokens',
          icon: KeyRound,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
        },
        {
          title: 'User Guide API Keys',
          url: '/admin/user-guide-api-keys',
          icon: KeyRound,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
        {
          title: 'Manage FCM Tokens',
          url: '/admin/fcm-tokens',
          icon: Bell,
          role: [Role.SUPER_ADMIN, Role.ADMIN],
          feature: Feature.ADMIN_RESOURCE,
        },
      ],
    },
  ],
}
